import { SubtypeState, SubtypeProperty, PropertyType, PropertyTypes, PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { subtypeDefaultProperties } from "../../../../types/actionModule/actionModuleTypes";
import { useTranslation } from "react-i18next";
import BooleanPropertyEditor from "./BooleanPropertyEditor";
import IntegerPropertyEditor from "./IntegerPropertyEditor";
import TextPropertyEditor from "./TextPropertyEditor";

interface Props {
    selectedSubtype?: SubtypeState;
    onChange: (oldSubtype: SubtypeState, newSubtypes: SubtypeState) => void;
}

export default function SubtypePropertyEditor(props: Props) {
    const { t } = useTranslation();

    const subtype = props.selectedSubtype;
    if (subtype === undefined) {
        return <></>
    }

    const subtypePropertyBuilder = (p: SubtypeProperty) => {
        return <div
            key={p.name}
            style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "start",
                alignItems: "start",
            }}>
            <div>
                <h5 style={{ padding: 0, margin: 0 }}>{t(p.displayName)}</h5>
                <PropertyEditor
                    key={p.name}
                    property={p}
                    subtype={subtype}
                    onChanged={(s) => props.onChange(subtype, s)} />
            </div>
        </div>
    };

    return <div
        key={subtype.editorId}
        style={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            overflowY: "auto",
        }}>
        {
            subtypeDefaultProperties.map(subtypePropertyBuilder)
        }
        {
            subtype.definition.editableProperties.map(subtypePropertyBuilder)
        }
    </div>;
}

interface GenericPropertyEditorProps {
    property: SubtypeProperty;
    subtype: SubtypeState;
    onChanged: (newState: SubtypeState) => void;
}

function PropertyEditor(props: GenericPropertyEditorProps) {
    const { t } = useTranslation();
    const value = props.subtype.properties[props.property.name];
    const onChanged = (newValue: PropertyType | undefined): void => {
        // Directly modify the property state and call the on changed callback with
        // the original instance to make state management easier
        if (newValue) {
            props.subtype.properties[props.property.name] = newValue;
        }
        else {
            delete props.subtype.properties[props.property.name];
        }

        props.onChanged(props.subtype);
    }

    if (props.property.editor) {
        if (props.property.editor) {
            return props.property.editor({
                value,
                onChanged,
                property: props.property,
                subtype: props.subtype,
            });
        }
    }

    switch (props.property.propertyType) {
        case PropertyTypes.text:
            return <TextPropertyEditor
                value={value}
                onChanged={onChanged}
                property={props.property}
                subtype={props.subtype} />
        case PropertyTypes.boolean:
            return <BooleanPropertyEditor
                value={value}
                onChanged={onChanged}
                property={props.property}
                subtype={props.subtype} />
        case PropertyTypes.integer:
            return <IntegerPropertyEditor
                value={value}
                onChanged={onChanged}
                property={props.property}
                subtype={props.subtype} />
        default:
            break;
    }

    return <>{t("actionModuleEditor.tabSubtypes.notEditableProperty")}</>
}
